<mat-expansion-panel
    class="w-100"
    [class.mt-12]="index > 0"
    [(expanded)]="expanded">
    <mat-expansion-panel-header class="w-100"
                                fxLayout="start space-between">
        <mat-panel-title class="no-wrap t2-semi-bold">
            <div class="radius-4 bc-primary-green-100 c-primary-gray-900 pl-12 pr-12">
                {{ 'i18n_af_labelMsisdnFraudEntryTitle' | translate: {index: index + 1} }}
            </div>
        </mat-panel-title>
        @if (hasDeleteButton) {
            <mat-panel-description fxLayoutAlign="end">
                <ui-kit-button type="text"
                               color="accent"
                               class="mr-16"
                               [isSmall]="true"
                               (clickListener)="deleteEntryListener.emit(index)"
                               [label]="'i18n_af_buttonDeleteMsisdnFraudEntry' | translate"/>
            </mat-panel-description>
        }
    </mat-expansion-panel-header>
    <div class="w-100" fxLayout="column" fxLayoutAlign="start start">
        @if (expanded && form) {
            <af-msisdn-fraud-form [form]="form"/>
        }
        @if (hasAddEntryButton) {
            <ui-kit-button
                type="text"
                class="mt-24"
                fxFlexAlign="start"
                iconPosition="left"
                [disabled]="isAddEntryButtonDisabled"
                [label]="'i18n_af_buttonAddMsisdnFraudEntry' | translate"
                icon="ic_add_circle"
                (clickListener)="addNewEntryListener.emit()"/>
        }
    </div>
</mat-expansion-panel>
